// Module
var code = "<div class=\"im-multiple-menu\"> <div class=\"im-multiple-close\"></div> <div class=\"im-multiple-selections\"></div> </div> ";
// Exports
module.exports = code;